<template>
  <div class="be-code" v-loading="loading">
    <el-form-item :class="{'is-error':error,'show-button':column.isButtonShow!==false}" class="date-time-item">
      <el-input class='code-ipt' v-model="code" @blur="checkCodeRepeat" :disabled="column.disabled"></el-input>
      <el-button class="code-btn" type="primary" @click="getCode" v-if="column.isButtonShow!==false">
        {{column.isButtonShow}}自动生成
      </el-button>
      <div v-show="error" class="el-form-item__error">{{errorMsg}}</div>
    </el-form-item>
  </div>
</template>
<script>
export default {
  props: ['column'],
  data() {
    return {
      loading: false,
      code: '',
      errorMsg: '',
      error: false
    }
  },
  methods: {
    //所有子组件必有此方法为当前数据赋值
    setValue(formModel) {
      formModel = formModel || this.$store.state[this.$utils.storeKeys.CURRENTFORM];
      this.code = formModel[this.column.prop];
    },
    getCode() {
      let params = '';
      if (this.column.codeType) {
        params = '?type=' + this.column.codeType;
        if (this.column.param) {
          params += '&' + this.$utils.JSONToString(this.column.param || {});
        }
      } else if (this.column.param) {
        params = '？' + this.$utils.JSONToString(this.column.param || {});
      }
      this.loading = true;
      this.$axios.fetchGet(this.column.url + params, {}).then(result => {
        this.loading = false;
        if (result.code == 200) {
          this.code = result.data;
          this.$store.commit(this.$utils.storeKeys.SETFORMDATA, {
            key: this.column.prop,
            value: this.code
          });
          this.$emit('changeCode',this.code)
        } else {
          this.$message({type: 'error', message: result.msg});
        }
      })
        .catch(err => {
          this.loading = false;
          this.$message({type: 'error', message: '获取失败!'});
        })
    },
    checkCodeRepeat() {
      if (this.code == '' || !this.column.checkUrl) {
        this.$store.commit(this.$utils.storeKeys.SETFORMDATA, {
          key: this.column.prop,
          value: this.code
        });
        return;
      }
      this.loading = true;
      this.$axios.fetchGet(this.column.checkUrl + '?' + this.column.prop + '=' + this.code, {}).then(result => {
        this.loading = false;
        if (result.data == false) {
          this.error = true;
          if (this.column.tipsInfo) {
            this.errorMsg = this.column.tipsInfo;
            this.$message({type: 'error', message: this.column.tipsInfo});
          } else {
            this.errorMsg = '编码重复请重新输入';
            this.$message({type: 'error', message: '编码重复请重新输入'});
          }
        } else if (result.code != 200) {
          this.error = true;
          this.errorMsg = '验证失败';
          this.$message({type: 'error', message: '验证失败'});
        } else {
          this.error = false;
          this.$store.commit(this.$utils.storeKeys.SETFORMDATA, {
            key: this.column.prop,
            value: this.code
          });
          this.$emit('changeCode',this.code)
        }
      })
        .catch(err => {
          this.loading = false;
          this.$message({type: 'error', message: '获取失败!'});
        })
    },
    getFormData() {
      if (this.column.rule && this.column.rule.length > 0) {
        let requireRule = this.column.rule.filter(item => {
          return item.required == true
        });
        if ((this.code == null || this.code.length == 0) && requireRule.length > 0) {
          this.error = true;
          this.errorMsg = this.column.rule.filter(item => {
            return item.required == true
          })[0].message;
        }
      }
      if (this.error) {
        return false;
      } else {
        return this.code;
      }
    },
    clearData() {
      this.code = '';
      this.$store.commit(this.$utils.storeKeys.SETFORMDATA, {
        key: this.column.prop,
        value: ''
      });
    },
  }
}
</script>
<style>
.be-code .show-button .code-ipt {
  width: 150px;
  max-width: 62.5%;
  margin-right: 10px;
}

.be-code .code-btn {
  min-width: 80px;
  max-width: 33.33%;
}
</style>



// WEBPACK FOOTER //
// src/components/controls/beCode.vue